<template>
  <div class="breadcrumb">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb"
};
</script>

<style scoped lang="scss">
.breadcrumb {
  color: #333;
  font-size: 17px;
  margin-bottom: 20px;
}
</style>
